export default {
      id: "btn_cross-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite.svg#btn_cross",
      toString: function () {
        return this.url;
      }
    }